var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-head-info`]},[_c('Row',[_c('Col',{attrs:{"xs":12,"md":6,"lg":4}},[_vm._t("1"),(_vm.isTablet)?_vm._t("2"):_vm._e()],2),(!_vm.isTablet)?_c('Col',{attrs:{"xs":12,"md":6,"lg":4}},[_vm._t("2")],2):_vm._e(),_c('Col',{attrs:{"xs":12,"md":6,"lg":4}},[_vm._t("3")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }